<template>
  <div id="batch-list">
    <div class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center">
      <div class="d-flex justify-content-between ">
        <h4 class="m-0 ">
          Batch Endpoint
        </h4>
        <b-button
          size="sm"
          class="ml-1 mr-3"
          @click="onAddNewBatchClick"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
          Create new batch
        </b-button>
      </div>
    </div>

    <content-spinner :show="loading" />

    <div
      v-if="!loading"
      class="inner-content p-3"
    >
      <complex-table-view
        :is-file-manipulation-controller="true"
        :small="true"
        :fields="fields"
        :items="items"
        :total-rows="items.length"
        :modal-name="`batch-list-view`"
        :action-buttons="actionButtons"
        @on-edit="onEditClick"
        @on-delete="onDeleteClick"
        @filter="onFilter"
      />
    </div>

    <add-edit-batch-endpoint-modal />
    <batch-file-list-view-modal />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ComplexTableView from '../../../core/components/complex-table/components/ComplexTableView';
import ContentSpinner from '../../../core/components/ContentSpinner';
import AddEditBatchEndpointModal from './components/AddEditBatchEndpointModal';
import BatchFileListViewModal from '../BatchList/components/BatchFileListViewModal';
import filterMixin from '../../../core/mixins/filter.mixin';
import {deleteConnectorBatch} from '../../../store/modules/file-manipulation-controller/actions';

const {mapActions, mapState} = createNamespacedHelpers('fileManipulationController');
const {mapActions: mapConnectorActions} = createNamespacedHelpers('connectorScreen');

export default {
  name: 'BatchEndpointView',
  mixins: [filterMixin],
  data() {
    return {
      loading: false,
      fields: [
        {
          key: 'batchName',
          name: 'batchName',
          dataTypeName: 'text',
          label: 'Name',
        },
      ],
      items: [],
      actionButtons: {
        delete: true,
        fileList: true,
      },
    };
  },
  watch: {
    ['batchList']() {
      this.items = [...this.batchList];
    },
  },
  computed: {
    ...mapState({
      batchList: state => state.batchList,
    }),
  },
  methods: {
    ...mapActions([
      'getBatchEndpointList',
      'deleteConnectorBatch',
      'showBatchFileListModal',
      'showAddEditBatchEndpointModal',
    ]),
    ...mapConnectorActions([
      'getAllConnector',
      'getPitchBookEndpoints',
    ]),
    onAddNewBatchClick() {
      this.showAddEditBatchEndpointModal();
    },
    onEditClick(item) {
      this.showAddEditBatchEndpointModal(item);
    },
    onFilter(filters) {
      const filter = filters.filter || filters;
      this.items = this.batchList.filter(item => {
        for (const filterFieldName in filter) {
          if (!filter.hasOwnProperty(filterFieldName)) {
            continue;
          }
          const field = this.fields.find((f) => f.name === filterFieldName);
          if (field.dataTypeName === this.fieldValues.text && !this.textFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          }
        }
        return true;
      });
    },
    async onDeleteClick(index) {

      const confirmed = await this.$confirm('Deleting Record...', 'You are deleting record. Are you sure you want to continue?');

      if (confirmed) {
        const batch = this.batchList.find((b, idx) => idx === index);

        const {success, body} = await this.deleteConnectorBatch(batch);
        if (success) {
          this.$toasted.success('Batch deleted successfully', {
            duration: TOASTER_DURATION,
          });
        } else {
          this.$toasted.error(body.ErrorMessage, {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
    async getData() {
      await this.getBatchEndpointList();
      await this.getAllConnector();
      await this.getPitchBookEndpoints({
        keyMap: true,
      });
    },
    prepareData() {
      this.items = [...this.batchList];
    },
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.prepareData();
    this.loading = false;
  },
  components: {
    BatchFileListViewModal,
    AddEditBatchEndpointModal,
    ContentSpinner,
    ComplexTableView,
  },
};
</script>

<style lang="scss">
#batch-list {

  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .action-th {
    width: 100px;
  }

  th.th-errors {
    min-width: 200px;
  }

  .inner-content {
    overflow: auto;
    flex: 1;
  }

  .card-body {
    padding: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 24px;
    overflow: hidden;
    justify-content: flex-start;
  }

  tbody {
    tr:hover {
      cursor: pointer;
      background-color: #d0d0d0;
    }
  }

}
</style>